import { ActionMeta } from 'react-select';

import { ActivationTypes } from '@/api/enums/ActivationTypes.ts';
import { CategoriesRes, StandardResponseItem } from '@/api/types';

export type PickPropertiesOfType<T, U> = {
    [K in keyof T as T[K] extends U ? K : never]: T[K];
};

export enum SearchFilters {
    categories = 'Категория',
    operators = 'Оператор',
    regions = 'Регион',
    tariffs = 'Тариф',
    priceRange = 'Стоимость',
    device = 'Устройство',
}

export type ChosenNumber = {
    numberCost: number;
    activationFee: number;
    operator: string;
    tariff: string;
    tariffSid: string;
    minTariffPrice: number;
    tariffs: string[];
    number: string;
    region: string;
    price: number;
    tariffMin: string;
    tariffInternet: string;
    tariffSms: string;
    deviceType: string;
};

export type DropdownOption<T> = {
    label: string;
    value: T;
};

export type DropdownOptions<T> = Array<DropdownOption<T>>;

export type SelectOnChange = (newValue: unknown, actionMeta: ActionMeta<unknown>) => void;

export type OperatorIcon = {
    id: number;
    name: string;
};

export type CategoriesWithStatuses = Array<CategoriesRes & { active: boolean }>;
export type OperatorsWithStatuses = Array<StandardResponseItem & { active: boolean }>;
export type DeviceTypesWithStatuses = Array<StandardResponseItem & { active: boolean }>;

export type DeliveryMethod = keyof typeof ActivationTypes;
